import request from "@/utils/request";

const blockedItems = () => request
  .get("/api/blocklist")
  .then(response => response.blocklist);

export default {
  blockedItems
};
